import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Form, Button, Container, Card, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { FaCalculator, FaEye, FaCommentDots, FaMusic, FaRunning, FaUsers } from 'react-icons/fa';

const M14_Ejercicio7 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    
    const [respuestas, setRespuestas] = useState({
        identificacion: {
            concepto_principal: '',
            categorias: '',
            caracteristicas: ''
        },
        cuadro: {
            matematica: '',
            visual: '',
            verbal: '',
            musical: '',
            kinestesica: '',
            interpersonal: ''
        }
    });

    const textoBase = `INTELIGENCIAS

Existen diferentes tipos de inteligencia que permiten a las personas desenvolverse en distintos ámbitos:

- Inteligencia matemática o racional: relacionada con el uso de números, lógica y resolución de problemas.
- Inteligencia visual o espacial: capacidad para percibir el mundo visual y transformarlo mentalmente.
- Inteligencia verbal o auditiva: relacionada con el lenguaje, la comunicación y la comprensión.
- Inteligencia musical o rítmica: capacidad de percibir, discriminar y expresar formas musicales.
- Inteligencia kinestésica: relacionada con el control del cuerpo y el movimiento.
- Inteligencia interpersonal: capacidad de comprender a otras personas e interactuar con ellas.`;

    const handleIdentificacion = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            identificacion: { ...prev.identificacion, [campo]: valor }
        }));
    };

    const handleCuadro = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            cuadro: { ...prev.cuadro, [campo]: valor }
        }));
    };

    const nextStep = () => {
        if (!modoConsulta && (step === 2)) {
            const { concepto_principal, categorias, caracteristicas } = respuestas.identificacion;
            if (!concepto_principal.trim() || !categorias.trim() || !caracteristicas.trim()) {
                Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Por favor completa todas las áreas de identificación.' });
                return;
            }
        }
        setStep(prev => prev + 1);
    };

    const prevStep = () => setStep(prev => prev - 1);

    const calcularPuntaje = () => {
        let puntaje = 0;
        
        // FASE 1: Identificación (10 pts)
        if (respuestas.identificacion.concepto_principal.trim().length > 5) puntaje += 2;
        if (respuestas.identificacion.categorias.trim().length > 15) puntaje += 4;
        if (respuestas.identificacion.caracteristicas.trim().length > 20) puntaje += 4;
        
        // FASE 2: Cuadro Sinóptico (10 pts)
        const completadas = Object.values(respuestas.cuadro).filter(val => val.trim().length > 5).length;
        puntaje += Math.floor((completadas / 6) * 10);

        return puntaje;
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        const completadas = Object.values(respuestas.cuadro).filter(val => val.trim() !== '');
        if (completadas.length < 6) {
            Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Debes completar la definición para todas las inteligencias en el cuadro.' });
            return;
        }

        const puntajeFinal = calcularPuntaje();

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio 7 - Cuadros sinópticos (Inteligencias)",
                nivel: "Avanzado",
                modulo: "14",
                createdAt: new Date(),
                tipo: "Cuadro Sinóptico",
                respuestas: respuestas,
                puntaje: puntajeFinal,
                puntajeMaximo: 20
            });
            Swal.fire({
                title: '¡Evaluación Enviada!',
                text: `Resultados enviados con éxito. Puntaje estimado: ${puntajeFinal}/20.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then((result) => {
                if (result.isConfirmed) {
                    cerrarModal();
                }
            });
        } catch (error) {
            console.error("Error al enviar las respuestas: ", error);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Error al enviar las respuestas.' });
        }
    };

    const categoriasUI = [
        { id: 'matematica', nombre: 'Matemática', icon: <FaCalculator size={30} className="text-primary mb-2"/>, color: 'border-primary' },
        { id: 'visual', nombre: 'Visual', icon: <FaEye size={30} className="text-success mb-2"/>, color: 'border-success' },
        { id: 'verbal', nombre: 'Verbal', icon: <FaCommentDots size={30} className="text-info mb-2"/>, color: 'border-info' },
        { id: 'musical', nombre: 'Musical', icon: <FaMusic size={30} className="text-warning mb-2"/>, color: 'border-warning' },
        { id: 'kinestesica', nombre: 'Kinestésica', icon: <FaRunning size={30} className="text-danger mb-2"/>, color: 'border-danger' },
        { id: 'interpersonal', nombre: 'Interpersonal', icon: <FaUsers size={30} className="text-secondary mb-2"/>, color: 'border-secondary' }
    ];

    return (
        <Container>
            <h3 className="text-center mb-4">Ejercicio 7 - Cuadros Sinópticos</h3>
            
            {step === 1 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-primary">
                        <Card.Body>
                            <Card.Title>FASE 1: Comprensión (Lectura)</Card.Title>
                            <Card.Text>Lee el siguiente texto cuidadosamente.</Card.Text>
                            <div className="p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
                                {textoBase}
                            </div>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente: Identificación</Button>
                    </div>
                </div>
            )}

            {step === 2 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-warning">
                        <Card.Body>
                            <Card.Title>FASE 1: Identificación</Card.Title>
                            <Card.Text>Extrae los elementos clave del texto leído.</Card.Text>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Concepto Principal:</Form.Label>
                            <Form.Control type="text" placeholder="Ej: Tipos de Inteligencia" value={respuestas.identificacion.concepto_principal} onChange={e => handleIdentificacion('concepto_principal', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Categorías (Tipos enumerados):</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Lista los tipos de inteligencia..." value={respuestas.identificacion.categorias} onChange={e => handleIdentificacion('categorias', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Características Generales:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="¿Qué características las diferencian?" value={respuestas.identificacion.caracteristicas} onChange={e => handleIdentificacion('caracteristicas', e.target.value)} />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente: Cuadro Sinóptico</Button>
                    </div>
                </div>
            )}

            {step === 3 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-success">
                        <Card.Body>
                            <Card.Title>FASES 2 y 3: Estructuración Visual</Card.Title>
                            <Card.Text>Completa el cuadro sinóptico escribiendo la definición breve de cada inteligencia.</Card.Text>
                        </Card.Body>
                    </Card>
                    
                    <div className="text-center mb-5">
                        <h4 className="p-3 bg-dark text-white rounded d-inline-block shadow-lg">INTELIGENCIAS</h4>
                        <div style={{ height: '30px', borderLeft: '3px solid #343a40', width: '3px', margin: '0 auto' }}></div>
                        <div style={{ height: '3px', backgroundColor: '#343a40', width: '80%', margin: '0 auto' }}></div>
                    </div>

                    <Form>
                        <Row className="g-3 justify-content-center">
                            {categoriasUI.map((cat, index) => (
                                <Col xs={12} md={6} lg={4} key={index}>
                                    <Card className={`h-100 shadow-sm ${cat.color} text-center`}>
                                        <Card.Header className="bg-white border-bottom-0 pt-4">
                                            {cat.icon}
                                            <h6 className="fw-bold mb-0">{cat.nombre}</h6>
                                        </Card.Header>
                                        <Card.Body className="bg-light">
                                            <Form.Control 
                                                as="textarea" 
                                                rows={3} 
                                                placeholder="Definición breve..." 
                                                value={respuestas.cuadro[cat.id]}
                                                onChange={e => handleCuadro(cat.id, e.target.value)}
                                                style={{ resize: 'none' }}
                                            />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Form>
                    <div className="d-flex justify-content-between mt-5">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="success" size="lg" onClick={enviarResultados}>Finalizar y Enviar</Button>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default M14_Ejercicio7;